module.exports = __webpack_public_path__ + "img/icon-hearth.4e541ef2.png";